// extracted by mini-css-extract-plugin
export var suggestions = "locationSelector-module--suggestions--x0kg-";
export var activeSuggestion = "locationSelector-module--activeSuggestion--PlDrR";
export var isIntro = "locationSelector-module--isIntro--i3iDi";
export var suggestionsActive = "locationSelector-module--suggestionsActive--OcAAd locationSelector-module--suggestions--x0kg-";
export var slideUp = "locationSelector-module--slideUp--QAhu+";
export var slideUpLarge = "locationSelector-module--slideUpLarge--uANEa";